import setReduxAction from 'modules/redux/actions/set'
import { SEARCH_ACTION, SEARCH_PATH } from 'modules/search/constants'

export default function updateSearchAction (query = '') {
  return dispatch => {
    dispatch(
      setReduxAction({
        type: SEARCH_ACTION.UPDATE_QUERY,
        payload: {
          path: SEARCH_PATH.QUERY,
          value: query
        }
      })
    )
  }
}
